import { BaseApiService } from '../base/BaseApiService';

export type WhatsAppValidationStatus = 'unknown' | 'loading' | 'has' | 'no' | 'error';

export interface WhatsAppPhoneValidationResult {
  phone: string;
  hasWhatsApp: boolean | null;
  fromCache: boolean;
  validatedAt?: string | null;
  errorMessage?: string | null;
}

export class WhatsAppValidationService extends BaseApiService {
  /**
   * Validação unitária on-demand (uma linha por vez).
   * GET /api/v1/whatsapp/validate/{phone} — cache 24h no backend.
   */
  async validatePhone(phone: string): Promise<WhatsAppPhoneValidationResult> {
    const cleaned = phone.replace(/\D/g, '');
    const response = await this.api.get<WhatsAppPhoneValidationResult>(`/v1/whatsapp/validate/${cleaned}`);
    return response.data;
  }
}

export const whatsAppValidationService = new WhatsAppValidationService();

export const mapWhatsAppResultToStatus = (result: WhatsAppPhoneValidationResult): WhatsAppValidationStatus => {
  if (result.errorMessage || result.hasWhatsApp === null || result.hasWhatsApp === undefined) {
    return 'error';
  }
  return result.hasWhatsApp ? 'has' : 'no';
};
